import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Document from './../../../../../../components/document';
import { history } from './../../../../../../configuration/store';
import { PERMISSIONS } from './../../../../../../components/document/types';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getAdmin, submitICNotify } from '../../../../../../reducers/onboarding';
import { setJobProgress } from '../../../../../../reducers/jobs';
import { HelpButton } from '../../../../../../components/richButtons';
import messages from '../../../../../../text/messages';
import { setProgress } from '../../../../../../reducers/wizard';
import { createDocuments } from '../../../../../../reducers/documents';
import mixpanel from 'mixpanel-browser';
import { icDocuments, icDocumentsList } from '../../../../../../utilities/regime';

class DocumentUploadStep extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            documentsStatus: {}
        };

        this.submit = this.submit.bind(this);
        this.handleDoc = this.handleDoc.bind(this);
        this.renderUploadButton = this.renderUploadButton.bind(this);
        this.renderDocumentRow = this.renderDocumentRow.bind(this);
        this.getDocumentModel = this.getDocumentModel.bind(this);
        this.notHaveAllDocumentsStatus = this.notHaveAllDocumentsStatus.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'DocumentUploadStep' } });

        const { admin, client, getAdmin } = this.props;
        if (!admin) getAdmin(client.admin_id);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { documents, IC_DOCUMENTS } = nextProps;
        if (!documents) {
            return;
        }
        const documentsStatus = {};

        Object.entries(IC_DOCUMENTS).forEach(([key, d]) => {
            const doc = documents[d.id] || {};
            if (doc.list && doc.list.length) {
                documentsStatus[key] = null;
            } else if (this.state.documentsStatus[key] === null) {
                documentsStatus[key] = undefined;
            }
        });

        this.setState({ documentsStatus: { ...this.state.documentsStatus, ...documentsStatus } });
    }

    notHaveAllDocumentsStatus() {
        const { IC_DOCUMENTS } = this.props;
        const { documentsStatus } = this.state;
        return Object.entries(IC_DOCUMENTS).some(([_, doc]) => documentsStatus[doc.type] === undefined);
    }

    getDocumentModel(doc, status) {
        const { role } = this.props;

        return {
            doc_type: doc.type,
            display_name: doc.label,
            name: `${doc.id}_${role.id}`,
            ref_id: role.id,
            ref_type: role.type,
            permissions: PERMISSIONS.CLIENT_UPLOAD,
            status
        };
    }

    submit() {
        const { submitICNotify, job, setJobProgress, setProgress, createDocuments, IC_DOCUMENTS } = this.props;
        const { documentsStatus } = this.state;
        const progress = { step: 3, branch: 'ic-continue-request' };

        const docs = Object.entries(IC_DOCUMENTS).reduce((d, [_, doc]) => {
            const status = documentsStatus[doc.type];
            if (status) {
                d.push(this.getDocumentModel(doc, status));
            }
            return d;
        }, []);

        createDocuments(docs, () => {
            submitICNotify(job);
            setProgress({ entity: 'job', id: job.id }, progress, () => {
                setJobProgress(job.id, progress);
                history.push('/dashboard');
            });
        });
    }

    handleDoc(status, documentType, click = () => null) {
        const { documentsStatus } = this.state;
        documentsStatus[documentType] = status;
        this.setState({ documentsStatus }, click);
    }

    renderUploadButton(click, type) {
        const { documents, IC_DOCUMENTS } = this.props;

        if (!documents) {
            return;
        }

        if (!IC_DOCUMENTS[type]) return null;

        const { documentsStatus } = this.state;
        const docId = IC_DOCUMENTS[type].id;
        const docsByType = documents[docId] ? documents[docId].list.length : 0;

        return documentsStatus[type] ? (
            <div className="document-actions">
                <div className="selected">
                    {documentsStatus[type] === 'later' ? (
                        <FormattedMessage {...messages.willSubmitLater} />
                    ) : (
                        <FormattedMessage {...messages.dontHaveDocument} />
                    )}
                </div>
                <div onClick={() => this.handleDoc(undefined, type)} className="action">
                    <FormattedMessage {...messages.change} />
                </div>
            </div>
        ) : docsByType ? (
            <div className="document-actions">
                <div onClick={() => this.handleDoc(null, type, click)} className="button optionalButton">
                    <FormattedMessage {...messages.uploadMore} />
                </div>
            </div>
        ) : (
            <div className="document-actions">
                <div onClick={() => this.handleDoc(null, type, click)} className="button">
                    <FormattedMessage {...messages.upload} />
                </div>
                <div onClick={() => this.handleDoc('later', type)} className="action">
                    <FormattedMessage {...messages.submitLater} />
                </div>
                <div onClick={() => this.handleDoc('never', type)} className="action">
                    <FormattedMessage {...messages.dontHave} />
                </div>
            </div>
        );
    }

    renderDocumentRow(docInfo) {
        const { id, type, label, helpText, limit } = docInfo;
        const multipleClass = limit > 1 ? ' documentMarketing' : '';
        return (
            <div className="document-wrapper">
                <div className="documentRow">
                    <div className="documentTitle">
                        <FormattedMessage id={`${id}-label`} defaultMessage={label} tagName={'h5'} />
                        <HelpButton text={<FormattedMessage id={`${id}-help`} defaultMessage={helpText} />} />
                    </div>
                    <div className="documentList">
                        <div className={multipleClass}>
                            <Document
                                id={id}
                                docType={type}
                                view={{ component: 'upload-later' }}
                                upload={{ limit, permissions: PERMISSIONS.CLIENT_UPLOAD, button: this.renderUploadButton }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, client, regime } = this.props;

        if (!admin) {
            return null;
        }
        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'icdoc.intro1'}
                            defaultMessage={`We need to verify certain documents that demonstrate your status as an independent business.`}
                            tagName={'h5'}
                        />
                    </div>
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'icdoc.intro3'}
                            defaultMessage={`
                              You may not have all these documents, but you should submit as many as you can.`}
                            values={{ co: client.name }}
                            tagName={'p'}
                        />
                    </div>
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'icdoc.intro4'}
                            defaultMessage={`
                              Not providing them may delay your application, or in some cases may mean that you should be paid as an individual rather than as a business.
                              <br><br>If you have any questions, contact us using the chat below, or email <a href="mailto:hr@greenlight.ai">hr@greenlight.ai</a>.`}
                            values={{ co: client.name }}
                            tagName={'p'}
                        />
                    </div>
                </div>

                <div className="row">{icDocuments(regime, this.renderDocumentRow)}</div>
                <WizardButtons
                    disabled={submitting || this.notHaveAllDocumentsStatus()}
                    back={{ action: back }}
                    submit={{ message: <FormattedMessage {...messages.submit} /> }}
                />
            </form>
        );
    }
}

DocumentUploadStep = reduxForm(formSettings)(DocumentUploadStep);

const mapStateToProps = (state, props) => {
    return {
        role: state.identity.role,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        documents: state.documents,
        IC_DOCUMENTS: icDocumentsList(props.regime)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin,
            submitICNotify,
            setProgress,
            setJobProgress,
            createDocuments
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUploadStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/documentUpload.jsx